import { createPopper } from '@popperjs/core';

// Show hide Image Hotspots Info boxes
var hotspotsBtns = Array.prototype.slice.call(document.getElementsByClassName('image-mapped-points__point__button'));

if(hotspotsBtns.length > 0){
  hotspotsBtns.forEach((button) => {
    button.addEventListener('click', ()=>{
      if(!button.parentElement.classList.contains('focused')){
        button.parentElement.classList.add('focused');
      }else{
        button.parentElement.classList.remove('focused');
      }
    });

    if(window.innerWidth > 550){
      createPopper(button, button.nextElementSibling, {
        placement: 'right-start',
        strategy: 'fixed',
      });
    }else{
      createPopper(button, button.nextElementSibling, {
        placement: 'bottom',
        strategy: 'fixed',
      });
    }
  });
}

